import TiptapTable from '@tiptap/extension-table';

const Table = TiptapTable.extend({
  resizable: true,
  lastColumnResizable: false,
  addAttributes() {
    return {
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) => {
          if (!attributes.style) return {};
          return { style: attributes.style };
        },
      },
      'data-noBorder': {
        default: null,
        parseHTML: (element) => element.getAttribute('data-noBorder'),
        renderHTML: (attributes) => {
          if (!attributes['data-noBorder']) return {};
          return { 'data-noBorder': attributes['data-noBorder'] };
        },
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    const isNoBorder = HTMLAttributes['data-noBorder'] === 'true';
    const isRoomCard =
      HTMLAttributes.class && String(HTMLAttributes.class).includes('tt2-room-row');

    // Clone HTMLAttributes to avoid direct mutation
    const attrs = { ...HTMLAttributes };

    if (isNoBorder && !isRoomCard) {
      attrs.class = attrs.class ? `${attrs.class} no-border` : 'no-border';

      attrs.style = `
      width: 100%;
      border: none;
      border-collapse: collapse;
      padding: 0;
      margin: 0;
      table-layout: fixed;
    `;
    } else if (isNoBorder && isRoomCard) {
      attrs.class = attrs.class ? `${attrs.class} no-border` : 'no-border';
      attrs.style = `
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      margin: 1.25rem 0 0;
      border: 1px solid #d1d5db;
      border-radius: 12px;
      background-color: #ffffff;
      box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
      table-layout: fixed;
    `;
    } else {
      attrs.style = `
      width: 100%;
      border: 1px solid #374151;
      border-collapse: collapse;
      border-radius: 0.25rem;
      box-sizing: border-box;
      padding: 0.5rem;
      margin-top: 2rem;
      margin-bottom: 2rem;
      table-layout: fixed;
    `;
    }

    return ['table', attrs, 0];
  },
});

export default Table;
